import { RootState } from "../rootReducer";
import { ViewAsState } from "./viewAs.reducer";

export const viewAsSelector = (state: RootState): ViewAsState => state.viewAs;

export const viewAsEndedSelector = (state: RootState): boolean =>
  state.viewAs.ended;

export const viewAsEndConfirmedSelector = (state: RootState): boolean =>
  state.viewAs.endConfirmed;
